import { UserManagerSettings } from "oidc-client";
import { createUserManager } from 'redux-oidc';

export const oAuthSettings = {
    authority: process.env.REACT_APP_AUTHORITY_URL,
    client_id: 'Revelation.NewUX',
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${process.env.PUBLIC_URL}/signin-callback`,//`${Constants.clientRoot}/signin-callback.html`,
    silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${process.env.PUBLIC_URL}/silent-renew`,
    automaticSilentRenew: true,
    post_logout_redirect_uri: `https://localhost:8090`,
    response_type: "code",
    scope: "offline_access Revelation.Api", //offline_access required for silent renew to work in the browser
    validateSubOnSilentRenew: false,
    includeIdTokenInSilentRenew: true,
    silentRequestTimeoutInSeconds: 30,
} as UserManagerSettings;

const userManager = createUserManager(oAuthSettings);
export default userManager;